import VoucherList from '../components/voucherGiftCards/VoucherList';
import VoucherWalletInfo from '../components/voucherGiftCards/VoucherWalletInfo';

const VoucherGiftCards = () => {
  return (
    <>
      <VoucherWalletInfo />
      <VoucherList />
    </>
  );
};

export default VoucherGiftCards;
